export default __webpack_public_path__ + "static/media/new_speedkino_policy.26254dcb.png";